export const getMarketingCarrierNames = (bounds = []) => {
  const marketingCarrierNames = bounds.flatMap(({ segments }) =>
    segments
      .map(
        ({ __typename, marketingCarrier }) => __typename === 'TripSegment' && marketingCarrier.name,
      )
      .filter(Boolean),
  );

  return Array.from(new Set(marketingCarrierNames));
};

export const getTicketingCarrierCodes = (bounds = []) => {
  const ticketingCarrierCodes = bounds.flatMap(({ segments }) =>
    segments
      .map(
        ({ __typename, ticketingCarrier }) => __typename === 'TripSegment' && ticketingCarrier.code,
      )
      .filter(Boolean),
  );

  return Array.from(new Set(ticketingCarrierCodes));
};

export const getOperatingCarrierCodes = (bounds = []) => {
  const operatingCarrierCodes = bounds.flatMap(({ segments }) =>
    segments
      .map(
        ({ __typename, operatingCarrier }) =>
          __typename === 'TripSegment' && operatingCarrier?.code,
      )
      .filter(Boolean),
  );

  return Array.from(new Set(operatingCarrierCodes));
};
